const { ccclass, property } = cc._decorator;
import ViewBase from "../../../../framework/core/mvvm/view_base";
import SpriteFrameHolder from "../../ui/spriteFrameHolder";

@ccclass
export default class DialogItemTipsView extends ViewBase {

    @property(cc.Label)
    labelName: cc.Label = null

    @property(cc.Label)
    labelDesc: cc.Label = null
    

    @property(cc.Sprite)
    iconSprite: cc.Sprite = null

    @property(SpriteFrameHolder)
    iconSpriteHolder: SpriteFrameHolder = null

    @property(cc.Layout)
    layout: cc.Layout = null


    showPanel(data: {type: number, name: string, desc: string, itemCode?: string, clickWorldPos: cc.Vec2}){
        let name = data.name
        let desc = data.desc
        let spriteFrameKey = ''
        switch (data.type) {
            case 5:
                spriteFrameKey = 'chip'
                break;
            case 6:
                spriteFrameKey = 'gold'
                break
            case 10:
                spriteFrameKey = data.itemCode
                break
            case 100:
                spriteFrameKey = 'daibi'
                break
            default:
                break;
        }
        this.setItem(this.iconSpriteHolder.getSpriteFrameByKey(spriteFrameKey), name, desc)
        this.layout.node.opacity = 0
        this.showRightPos(data.clickWorldPos)
    }

    setItem(spriteFrame: cc.SpriteFrame, name: string, desc: string){
        this.labelName.string = name
        this.labelDesc.string = desc
        this.iconSprite.spriteFrame = spriteFrame
        this.labelDesc['_forceUpdateRenderData'](true)
        this.layout['_doLayout']()
    }

    showRightPos(click_world_pos){
        this.layout.node.opacity = 255
        let localPos = this.layout.node.parent.convertToNodeSpaceAR(click_world_pos)
        let offset = cc.Vec2.ZERO
        if(localPos.y > 0){
            offset.y = 0
        }else{
            offset.y = this.layout.node.height
        }
        if(localPos.x > 0){
            offset.x = - this.layout.node.width * 0.5
        }else{
            offset.x = this.layout.node.width * 0.5
        }
        this.layout.node.position = cc.v3(localPos.add(offset))
    }


}
